import { useTheme } from "src/apps/providers/ThemeStore";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { OrderIdentityVerification } from "src/contexts/documentationArea/domain/OrderIdentityVerification";
import { IdentityVerificationDocumentSides } from "src/contexts/identityVerification/domain/IdentityVerificationDocumentSides";

interface OrderBoxHeaderIconProps {
  order: OrderIdentityVerification;
  side: IdentityVerificationDocumentSides;
}

export const IDVOrderBoxHeaderIcon = ({ order, side }: OrderBoxHeaderIconProps) => {
  const { successColor } = useTheme();
  if (order.getStagedFileFromSide(side)) {
    return <Icon color={successColor} path={ICON_PATHS.CHECK_CIRCLE_THIN} size={ICON_SIZES.s20} />;
  }
  return null;
};
